module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"try_delete_widget_in_amo":"Try delete widget in AMO"},"ua":{"try_delete_widget_in_amo":"Try delete widget in AMO"},"ru":{"try_delete_widget_in_amo":"Try delete widget in AMO"}}')
  delete Component.options._Ctor
}
